import { useEffect } from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  cursor: pointer;
  width: fit-content;
  /* align-self: flex-end; */
  background: ${(props) => (props.disabled ?  "#C1C5CF" : props.outlined ? "white" : props.color)};
  padding: 12px 32px;
  border: ${(props) => ( "2px solid " + (props.disabled ?  "#3E4451" : props.color))};
  font-weight: 600;
  color: ${(props) => (props.disabled ?  "#70798C" : props.outlined ? props.color : "#fff")};
  border-radius: 100px;
  transition: 300ms;
  font-size: 16px;
  ${({ disabled }) => !disabled && `
   &:hover {
    opacity: 0.8;
    /* background: ${(props) => (props.outlined &&  props.color )};
    color: ${(props) => (props.outlined && "#fff" )}; */
  }
  `}
`;

export function Button({
  text,
  outlined = false,
  color = "var(--secondary-forest-green)",
  readOnly = false,
  innerRef,
  forceClick,
  setForceClick,
  ...props
}) {
  useEffect(() => {
    if (forceClick) {
      innerRef.current.click();
      setForceClick(false);

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceClick]);
  return (
    <StyledButton ref={innerRef} disabled={readOnly} outlined={outlined} color={color} {...props}>
      {text}
    </StyledButton>
  );
}
